import {IPost} from "../interfaces/requests";
import {api} from "../../../helpers";

export const axiosPost = <Model>({url, data}: IPost<Model>) => {
  return api.post(url, data);
};
